import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import { SampleBase } from '../projects/sample-base';
import { ToastContainer, toast } from "react-toastify";
import Loader from 'react-loader-spinner';
import $ from 'jquery';


class ASRLanguageSettings extends SampleBase {
    constructor() {
        super(...arguments);
        this.state = {
            fields: {},
            errors: {},
            showStore: false,
            value: [],
            languages: [],
            languageString: '',
            dataFields: { text: 'nativeName' + '/' + 'language', value: 'language' },
            showCreateProjectStore: true,
            addedSuccessPopup: false,
            askToSavePopup: false,
            successResp: false,
            editedBooleanValue: false,
            nativeValue: [],
            errorMsg: "-1"

        }


    }
    fetchNativeLanguageApi() {
        var languageController = this;
        var value = [];
        var nativeValue = [];
        $.ajax({
            //url: "/api/asr-api-languages",
            url: "/api/project-languages",
            async: false,
            method: 'GET',
            data: { "projectId": localStorage.getItem("currentProjectId") },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    var languages = res.result.languages;

                    for (var i = 0; i < languages.length; i++) {
                        if (languages[i]['checked'] == true) {
                            value.push(languages[i]['language']);
                            nativeValue.push(languages[i]['nativeName']);
                        }
                    }
                    languageController.setState({ value: value, nativeValue: nativeValue });
                    languageController.setState({ editedBooleanValue: false })
                    languageController.languageInButtonForm(value, nativeValue);
                } else {
                    languageController.notifyFailToCreate(res.result);
                }

            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });

    }



    notifyLanguageAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Language Added Successfully</b>, {
            position: "top-center",


        });

    }
    notifyLanguageExceed(result) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;{result}</b>, {
            position: "bottom-center",

        });
        this.setState({
            errorMsg: "0"
        })

    }

    notifyFailToCreate(falseRes) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{falseRes}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    fetchLanguageApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var languageController = this;
        this.state.value = [];
        this.state.nativeValue = [];
        this.setState(this.state);
        $.ajax({
            //url: "/api/asr-api-languages",
            url: "/api/project-languages",
            async: false,
            method: 'GET',
            data: { "projectId": projectId },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    var languages = res.result.languages;
                    for (var i = 0; i < languages.length; i++) {
                        languageController.state.languages[i] = languages[i]['language'];
                        if (languages[i]['checked'] == true) {
                            languageController.state.value.push(languages[i]['language']);
                            languageController.state.nativeValue.push(languages[i]['nativeName']);
                        }
                    }
                    languageController.setState({ successResp: true, editedBooleanValue: false });
                    languageController.languageInButtonForm(languageController.state.value,
                        languageController.state.nativeValue);
                } else {
                    languageController.notifyFailToCreate(res.result);
                    languageController.setState({ successResp: false });
                }
            },
            error: function (xhr, status, error) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    notifyNoLangSelected() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Please select the languages that your speech recognition apis should support</b>, {
            position: "top-center"
        });
    }

    editLanguages = () => {

        this.setState({ editedBooleanValue: true })
    }
    updateLanguagesApi = () => {
        var languageUpdate = [];
        var updateLanguageController = this;
        if (document.getElementById("Selectlanguage").ej2_instances[0].value != null) {
            for (var i = 0; i < document.getElementById("Selectlanguage").ej2_instances[0].value.length; i++) {
                languageUpdate.push({ language: document.getElementById("Selectlanguage").ej2_instances[0].value[i], checked: true });
            }

            var languagesSelected = {
                "projectId": localStorage.getItem("currentProjectId"),
                languages: languageUpdate
            }
            $.ajax({
                // url: "/api/asr-api-languages",
                url: "/api/project-languages",
                async: false,
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(languagesSelected),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        updateLanguageController.notifyLanguageAdded()
                        updateLanguageController.setState({ editedBooleanValue: false })
                        updateLanguageController.fetchNativeLanguageApi();

                    } else {
                        updateLanguageController.notifyLanguageExceed(res.result)
                    }

                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }

            })
        }
    }
    refreshLanguages = () => {
        this.fetchNativeLanguageApi();
        this.setState({ editedBooleanValue: false })
    }
    languageInButtonForm(value, nativeValue) {
        var buttonElements = document.getElementById("appearance-for-selected-languages");
        if (buttonElements != null) {
            buttonElements.innerHTML = null;
            for (var i = 0; i < value.length; i++) {
                if (value[i] == "ENGLISH") {
                    buttonElements.innerHTML = buttonElements.innerHTML + "<button disabled=" + "true" + " " + "class=" + "bubble" + ">" + value[i] + "</button> &nbsp&nbsp";
                } else {
                    buttonElements.innerHTML = buttonElements.innerHTML + "<button disabled=" + "true" + " " + "class=" + "bubble" + ">" + nativeValue[i] + "&nbsp" + "&nbsp" + "|" + "&nbsp" + "&nbsp" + value[i] + "</button> &nbsp&nbsp";
                }
            }
        }
    }

    componentDidMount() {
        var thisController = this;
        setTimeout(() => {
            thisController.fetchLanguageApi();
        }, 300);
        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.fetchLanguageApi(event.projectId);
        });

    }

    render() {
        return (<div >
            <Loader
                type="TailSpin"
                color="#282a65"
                visible={this.state.successResp ? false : true}
                height={300}
                width={50}
                style={{ marginLeft: '400px' }}
            />
            <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
            {/* for reactToast */}
            <link rel="stylesheet" href="assets/css/ReactToastify.css" />
            <link rel="stylesheet" href="assets/css/material.css" />
            <link rel="stylesheet" href="assets/css/buttonForm.css" />

            {/* Content Wrapper. Contains page content */}
            <div className="wrapper" style={{ display: this.state.successResp ? 'block' : 'none', height: "450px" }}>

                <div className="container-fluid">
                    < ToastContainer className="Toast-at-center" />
                    <div className="row">
                        <div className="col-sm-5" style={{ marginRight: "0px" }}>
                            <h6 className="nav-item" style={{ color: '#282a65', marginTop: '20px' }}>Languages Supported </h6>
                            <div style={{ marginTop: "20px" }}>
                                Add or remove languages that your speech recognition api supports
                            </div> <br />

                            <div style={{ display: this.state.editedBooleanValue == true ? "none" : "block" }} id="appearance-for-selected-languages">
                                <br />

                            </div>

                            <div style={{ display: this.state.editedBooleanValue == true ? "block" : "none" }}>


                                <MultiSelectComponent id='Selectlanguage' dataSource={this.state.languages} fields={this.state.dataFields} placeholder='Select Languages' enabled={this.state.editedBooleanValue} style={{ borderBottomColor: "black" }} value={this.state.value} />

                            </div>

                            <button type="button" className="btn btn-primary pull-right navyblue-btn" onClick={this.updateLanguagesApi} hidden={!this.state.editedBooleanValue}>Save Changes</button>
                        </div>

                        <button className="btn action-button" style={{ marginTop: "40px" }}
                            title="Add or remove languages" onClick={this.editLanguages} hidden={this.state.editedBooleanValue} > <img className="img-responsive cursor-change" src="./assets/images/editWithWhiteFilled.png"

                            /></button>




                        <button className="btn action-button" style={{ marginTop: "40px", marginLeft: "0px" }}
                            title="Refresh" onClick={this.refreshLanguages}>
                            <img src="./assets/images/refresh_white_24dp.png" />
                        </button>


                    </div></div></div>

        </div>

        );
    }



}

export default ASRLanguageSettings;


// WEBPACK FOOTER //
// ./src/asrUi/ASRLanguageSettings.js